// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jx-0";
export var animationContainer = "_jx-1";
export var itemPrice = "_jx-a";
export var itemizedContent = "_jx-9";
export var itemizedHeader = "_jx-7";
export var itemizedRow = "_jx-8";
export var itemizedSection = "_jx-6";
export var modalContent = "_jx-2";
export var orderName = "_jx-3";
export var refundOption = "_jx-4";
export var refundOptionsContainer = "_jx-5";
export var shippingLabel = "_jx-b";
export var totalRow = "_jx-c";